import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseurl:'http://47.94.10.11:8008/',
    lang:'cn',
  },
  mutations: {
    set_lang(state,v){
      state.lang = v;
    },
  },
  actions: {
  },
  modules: {
  }
})
